import {Component} from "@angular/core";
import {RoleEnum} from "../../../model/enum/role-enum";
import {AuthService} from "../../../service/auth.service";
import {Router} from "@angular/router";


@Component({
  selector: 'app-cached-files-menuitem',
  template: `
    <div
      *ngIf="isCachedFilesVisible()"
      class="menu-div main-text-font" (click)="openCachedFiles()">
      <span class="fa fa-list black"></span>
      Cached files
    </div>`,
})
export class CachedFilesMenuItemComponent {

  constructor(private authService: AuthService,
              private router: Router) {
  }

  isCachedFilesVisible(): boolean {
    return this.authService.getRoles()?.findIndex(m => m.authority === RoleEnum.ROLE_POWER_USER) !== -1;
  }

  openCachedFiles() {
    this.router.navigateByUrl('/cached-files');
  }
}
